/**
 * Utility to post autologin message to the parent window from an iframe
 * @param {boolean} isOpenedInIframe If the request is handled in an iframe
 * @param {boolean} success Autologin success status
 * @param {string} error Error during autologin if any
 * @param {string} redirectLocation redirectlocation
 */
export function handleIframePostMessage(isOpenedInIframe, success, error, redirectLocation) {
    if (!isOpenedInIframe) {
        return;
    }
    let message;
    if (success) {
        message = {
            'action': 'login',
            'success': true,
            'redirect': null,
            'redirectlocation': redirectLocation
        };
    } else {
        message = {
            'action': 'login',
            'success': false,
            'error': error
        };
    }
    try {
        if (window.parent !== window.top) {
            window.parent.postMessage(JSON.stringify(message), '*');
        }
    } catch (exception) {
        console.error('Error, can not access parent element from iframe. Message will be posted only to top ', exception);
    }
    window.top.postMessage(JSON.stringify(message), "*");
}



// WEBPACK FOOTER //
// ./src/components/ExpLogin/utils/loginUtil.js